import type { SidebarProps } from '@/components/landing-page/components/sidebar';

export const defaults: Required<SidebarProps> = {
  groups: [],
};
